import styled from "styled-components";

export const HeroGraphics1Container = styled.div`
  width: 227px;
  height: 206px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 0px 10px 0px;
  box-sizing: border-box;
  overflow: hidden;

  @media screen and (max-width: 430px) {
    width: 131.96px;
    height: 119.75px;
    padding: 5px 0px 20px 0px;
    border: 1px solid red;
  }
`;

export const LottiHolder = styled.div`
  width: 90%;
  height: 150px;
  padding-left: 35px;
  padding-top: 30px;
  box-sizing: border-box;
  @media screen and (max-width: 430px) {
    width: 90px;
    height: 100px;
    margin-top: 50px;
    border: 1px solid red;
  }
  @media screen and (max-width: 375px) {
    width: 90px;
    height: 100px;
    margin-top: 50px;
  }
`;
